// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__JZAhB","disabled":"FileBtn_disabled__3AKjk","warn":"FileBtn_warn__1cD7q","fade":"FileBtn_fade__2PHtt"};